// src/Services/contacts.ts
//
// Ponto único dos canais de contato da Pertalks.
//
// Antes cada tela declarava seu próprio e-mail com fallback diferente, o que
// espalhava o mesmo endereço por vários arquivos. Mudar um canal aqui vale
// para o app inteiro.

/** Denúncias e reportes de conteúdo */
export const REPORT_EMAIL =
  process.env.REACT_APP_REPORT_EMAIL || "reporting@pertalks.com";

/**
 * Cadastro e liberação de estabelecimentos no mapa.
 * Usado quando o local não aparece na busca ou já está vinculado a outro usuário.
 */
export const PLACES_EMAIL =
  process.env.REACT_APP_PLACES_EMAIL || "places@pertalks.com";

/** WhatsApp Business — atendimento do plano Connection e superiores */
export const SUPPORT_WHATSAPP =
  process.env.REACT_APP_SUPPORT_WHATSAPP || "5511930958310";

/** Número formatado para exibição */
export const SUPPORT_WHATSAPP_LABEL = "(11) 93095-8310";

/**
 * Monta o link do WhatsApp com mensagem pré-preenchida.
 */
export const whatsappLink = (message?: string) => {
  const base = `https://wa.me/${SUPPORT_WHATSAPP}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

/**
 * Monta um mailto com assunto e corpo já preenchidos, para o contato chegar
 * com as informações que a equipe precisa.
 */
export const mailtoLink = (
  email: string,
  subject: string,
  body?: string,
) => {
  const params = [`subject=${encodeURIComponent(subject)}`];
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${email}?${params.join("&")}`;
};